//import './App.css';
//import './assets/css/content.css';
import { useState } from 'react';
import App from './App';
import oktaAuth from './components/auth/OktaConfig';
import { useNavigate } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';

function AppWithAuthentication() {
    const navigate = useNavigate();
    const restoreOriginalUri = (oktaAuth: any, originalUri: string) => {
        navigate(toRelativeUrl(originalUri || '/', window.location.origin));
    };

    const triggerLogin = async () => {
        await oktaAuth.signInWithRedirect();
    };

    const customAuthHandler = async () => {
        const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
        if (!previousAuthState || !previousAuthState.isAuthenticated) {
            // App initialization stage
            await triggerLogin();
        }
    };

    return (
        <>
            <Security
                oktaAuth={oktaAuth}
                restoreOriginalUri={restoreOriginalUri}
                onAuthRequired={customAuthHandler}
            >
                <App></App>
            </Security>
        </>
    );
}

export default AppWithAuthentication;
